import { render } from "./RecordAttendance.vue?vue&type=template&id=597e1f38&scoped=true"
import script from "./RecordAttendance.vue?vue&type=script&lang=js"
export * from "./RecordAttendance.vue?vue&type=script&lang=js"

import "./record-attendance.scss?vue&type=style&index=0&id=597e1f38&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597e1f38"]])

export default __exports__